import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Loading from './components/Loading';
import UnderDevelopment from './components/UnderDevelopment';

// Lazy load pages
const HomePage = React.lazy(() => import('./pages/HomePage'));
const ServicesPage = React.lazy(() => import('./pages/ServicesPage'));
const AboutPage = React.lazy(() => import('./pages/AboutPage'));
const PricingPage = React.lazy(() => import('./pages/PricingPage'));
const BlogPage = React.lazy(() => import('./pages/BlogPage'));
const ContactPage = React.lazy(() => import('./pages/ContactPage'));
const BlogPost = React.lazy(() => import('./components/BlogPost'));
const Stage1Tuning = React.lazy(() => import('./pages/services/Stage1Tuning'));
const Stage2Tuning = React.lazy(() => import('./pages/services/Stage2Tuning'));
const DPFSolutions = React.lazy(() => import('./pages/services/DPFSolutions'));
const EGRSolutions = React.lazy(() => import('./pages/services/EGRSolutions'));
const AdBlueSolutions = React.lazy(() => import('./pages/services/AdBlueSolutions'));

// Lazy load location pages
const CrawleyTuning = React.lazy(() => import('./pages/locations/CrawleyTuning'));
const GatwickTuning = React.lazy(() => import('./pages/locations/GatwickTuning'));

function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            
            {/* Service Routes */}
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/stage-1-tuning" element={<Stage1Tuning />} />
            <Route path="/services/stage-2-tuning" element={<Stage2Tuning />} />
            <Route path="/services/dpf-solutions" element={<DPFSolutions />} />
            <Route path="/services/egr-solutions" element={<EGRSolutions />} />
            <Route path="/services/adblue-solutions" element={<AdBlueSolutions />} />
            
            {/* Location Routes */}
            <Route path="/locations/crawley-tuning" element={<CrawleyTuning />} />
            <Route path="/locations/horsham-tuning" element={
              <UnderDevelopment 
                location="Horsham" 
                pageType="location"
                metaDescription="Professional ECU remapping in Horsham, West Sussex. Mobile service available. Enhance your vehicle's performance with our expert Horsham tuning team."
              />
            } />
            <Route path="/locations/reigate-tuning" element={
              <UnderDevelopment 
                location="Reigate" 
                pageType="location"
                metaDescription="ECU remapping services in Reigate, Surrey. Improve your vehicle's performance and fuel efficiency with our professional tuning services."
              />
            } />
            <Route path="/locations/gatwick-tuning" element={<GatwickTuning />} />
            <Route path="/locations/sussex-tuning" element={
              <UnderDevelopment 
                location="Sussex" 
                pageType="location"
                metaDescription="Professional ECU remapping throughout Sussex. Mobile service covering Brighton, Worthing, Eastbourne, and all Sussex areas."
              />
            } />
            <Route path="/locations/surrey-tuning" element={
              <UnderDevelopment 
                location="Surrey" 
                pageType="location"
                metaDescription="ECU remapping services across Surrey. From Guildford to Woking, our mobile tuning service covers all Surrey locations."
              />
            } />
            
            <Route path="/about" element={<AboutPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
